import React from "react";
import { useDispatch } from "react-redux";
import { forgotPassword } from "../../services/Action/OTPAction";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { useForm } from "@mantine/form";
import "react-toastify/dist/ReactToastify.css";
import {
	TextInput,
	AppShell,
	Text,
	useMantineTheme,
	Image,
	Button,
	Group,
	Box,
	Container,
} from "@mantine/core";
import imageIcon from "../../static/svg/ivistlogin.svg";
import Footr from "../../components/Footr";
import {
	showErrorNotification,
	showSuccessNotification,
} from "../../utils/Notifications";
function ForgotPassword() {
	const navigator = useNavigate();
	const dispatch = useDispatch();
	const theme = useMantineTheme();
	const form = useForm({
		initialValues: {
			Email: "",
		},

		validate: {
			Email: (value) =>
				/^\S+@\S+$/.test(value) ? null : "Invalid email",
		},
	});
	return (
		<AppShell
			styles={{
				main: {
					position: "relative",
					minHeight: "calc(100vh - 48px)",
					maxHeight: "auto",
					background:
						theme.colorScheme === "dark"
							? theme.colors.ivisit_dark[0]
							: theme.colors.gray[0],
				},
			}}
			footer={<Footr />}
		>
			<div
				style={{
					background: "#040F1F",
					margin: "auto",
				}}
			>
				<ToastContainer />
				<Container className="signupForm" size="xs" px="xs">
					<Group position="center" align="center">
						<Image src={imageIcon} width={270} pb={30} pt={50} />
					</Group>
					<Text
						style={{
							color: "white",
						}}
						align="center"
						size="xl"
						weight={700}
						pb={20}
					>
						Forgot Password
					</Text>
					<Box sx={{ maxWidth: 340 }} mx="auto">
						<form
							onSubmit={form.onSubmit(async (data) => {
								const result = dispatch(
									await forgotPassword(data)
								);
								if (result.payload.msg === "code sent") {
									navigator("/OTPForgotPassword");
									showSuccessNotification("sucess");
								} else {
									showErrorNotification("invalid Email");
								}
							})}
						>
							<TextInput
								placeholder="your@email.com"
								mr={10}
								styles={{
									input: { backgroundColor: "#252E3D" },
									root: {
										width: "100%",
										color: "white",
									},
								}}
								{...form.getInputProps("Email")}
							/>

							<div></div>
							<Group position="center" mt="lg">
								<Button
									style={{ width: "340px" }}
									type="submit"
								>
									Send
								</Button>
							</Group>
						</form>
					</Box>
				</Container>
			</div>
		</AppShell>
	);
}
export default ForgotPassword;
